import React from 'react';
import jwt_decode from 'jwt-decode';
import { useNavigate } from 'react-router-dom';

import validator from 'validator'
import Cookies from "js-cookie";

import { api, AUTH_CONFIG, SERVICE_TICKET } from '../services/Api';
import { tratarRetornoErroAxios } from '../pages/Erro/TratarRetornoErroAxios'

export const AuthContext = React.createContext();

export const AuthStorage = ({ children }) => {

  const [user, setUser] = React.useState(() => {

    let usuario = Cookies.get('hash');

    if (usuario) {

      usuario = JSON.parse(usuario);
      return jwt_decode(usuario);
    }
    return null;
  });
  const [erro, setErro] = React.useState({ delay: 5000, tipo: '', texto: '', url: '' });
  const [login, setLogin] = React.useState();
  const navigate = useNavigate();
  const callbackUri = `${window.location.origin}/auth`;

  const limparLocalESessionStorage = () => {
    Cookies.remove('hash')
    Cookies.remove('hash_u')
    sessionStorage.removeItem('hash');
    sessionStorage.removeItem('hash_u');
    localStorage.removeItem('hash');
    localStorage.removeItem('hash_u');
  }

  const menusEUnidadeSro = async (isRecuperStorage = false) => {
    if (isRecuperStorage === true) {

      let storageMenuUnidade = Cookies.get('hash_u');
      if (storageMenuUnidade) {

        storageMenuUnidade = JSON.parse(storageMenuUnidade);
        if (storageMenuUnidade.menus) setUser((user) => ({ ...user, menus: storageMenuUnidade.menus }));
        setUser((user) => ({ ...user, unidadeSro: storageMenuUnidade.unidadeSro }));
        return;
      }

    }

    let menusUnidadeSro = {};

    const responseMenus = await api.get(`/v1/usuarios/autenticado/menus`);

    if (responseMenus.status === 200) {
      const resmenus = await responseMenus.data;

      const isTemMenus = resmenus && resmenus.menus && Array.isArray(resmenus.menus) && resmenus.menus.length > 0;
      setUser((user) => ({ ...user, isTemMenus: isTemMenus }));
      setUser((user) => ({ ...user, isAdministrador: resmenus.isAdministrador }));
      setUser((user) => ({ ...user, menus: resmenus.menus }));
      setUser((user) => ({ ...user, funcionario: resmenus?.funcionario }));
      menusUnidadeSro.menus = resmenus.menus;
    }

    const responseUnidadeSro = await api.get('/v1/unidades/unidade-trabalho-sro');

    if (responseUnidadeSro.status === 200) {
      const resUnidadeSro = await responseUnidadeSro.data;

      setUser((user) => ({ ...user, unidadeSro: resUnidadeSro }));
      menusUnidadeSro.unidadeSro = resUnidadeSro;
    }

    if (menusUnidadeSro && Object.keys(menusUnidadeSro).length > 0)  Cookies.set('hash_u', JSON.stringify(menusUnidadeSro), { secure: true }); //localStorage.setItem('hash_u', hashCode(JSON.stringify(menusUnidadeSro)));

  };

  React.useEffect(() => {

    if (!AUTH_CONFIG.autoLogon) {
      return;
    }

    if (user) {

      if (!user.unidadeSro) {
        menusEUnidadeSro(true);
      }
      setLogin(() => true);
    } else {
      setLogin(() => false);
    }
  //eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  const loginUser = () => {
    localStorage.setItem('pathAfterLogin', '/');
    limparLocalESessionStorage();
    if (!validator.isURL(AUTH_CONFIG.loginUrl)) {
      return false;
    }
    if (!validator.isURL(AUTH_CONFIG.loginUrl)) {
      return false;
    }

    window.location.href = `${AUTH_CONFIG.loginUrl}?service=${callbackUri}`;
  }

  function temPermissao(funcionalidades) {
    return funcionalidades?.some((f) => user?.authorities?.includes(f));
  }

  const perfil = () => {
    navigate('/Perfil');
  };

  const perfilAlterarUnidadeTrabalho = () => {
    navigate('/alterar-unidade');
  };

  const logoutCasInBackgroud = async  () => {
    //Fazer logout no cas e voltar para a página de login do cas
    window.location.href = `${AUTH_CONFIG.logoutUrl}?service=${AUTH_CONFIG.loginUrl}/login?service=${callbackUri}`;
  }

  const logout = (e) => {
    e.stopPropagation();
    limparLocalESessionStorage();
    setUser(null);
    setLogin(false);
    logoutCasInBackgroud();
  };

  const buscaToken = React.useCallback(

    async (serviceTicket) => {
      limparLocalESessionStorage();
      const stRequest = SERVICE_TICKET({
        service: callbackUri,
        ticket: serviceTicket,
      });
      try {
        const response = await fetch(stRequest.url, stRequest.options);

        if (!response.ok) {
            setLogin(false);
          return false;
        }

        const json = await response.json();

        const jwt = json?.serviceResponse?.authenticationSuccess?.attributes?.jwt;
        const tipo = json?.serviceResponse?.authenticationSuccess?.attributes?.authenticationMethod;

        if (!jwt) {
          setLogin(false);
          return false;
        }

        Cookies.set('hash', JSON.stringify(jwt[0]),{secure:true});
        let jwtDecoded = jwt_decode(jwt[0]);

        jwtDecoded.tipo = !tipo || !Array.isArray(tipo) ? 'Correiosnet' : (tipo[0].charAt(0).toUpperCase() + tipo[0].substring(1)).replace("CPF", "").replace("cpf", "");  //publicacao[0].toUpperCase() + publicacao.substring(1);
        setUser(() => jwtDecoded);

        await menusEUnidadeSro();

        setLogin(true);

        return true;
      } catch (e) {
        console.log('Erro ao acessar /v1/usuarios/autenticado/menus: ', e);

        limparLocalESessionStorage();
        setUser(() => null);
        setLogin(() => false);
        setErro(() => tratarRetornoErroAxios(e));
        navigate("/erro");
        return false;

      }
  //eslint-disable-next-line react-hooks/exhaustive-deps
    },[callbackUri]
  );

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        login,
        loginUser,
        perfil,
        perfilAlterarUnidadeTrabalho,
        logout,
        buscaToken,
        temPermissao,
        menusEUnidadeSro,
        erro,
        setErro,
        limparLocalESessionStorage
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
